import { ValueTransformer } from "typeorm"

export const float2dp: ValueTransformer = {
  to: (entityValue: number) => entityValue * 10000,
  from: (databaseValue: number): number => databaseValue / 10000
}